import { VStack, Spinner, Text } from '@chakra-ui/react';
import React from 'react';

export const Loader = () => {
  return (
    <VStack h="100vh" justifyContent={'center'} alignItems={'center'} spacing={6}>
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="teal.500"
        size="xl"
      />
      <Text color="teal.600" fontWeight="600" fontSize="lg">Loading Dlabs...</Text>
    </VStack>
  );
};
